//  project imports
import MainCard from 'ui-component/cards/MainCard';
import Checkout from './Checkout/Chekcout';

// ==============================|| PAYMENTS ||============================== //

export const PaymentLandingPage = () => (
    <MainCard title={false} border={false} style={{ minHeight: '90%' }}>
        <Checkout />
    </MainCard>
);

export default PaymentLandingPage;
